declare var StackTrace: any;
class ErrorService {
    static errors: KnockoutObservableArray<ErrorBase> = ko.observableArray([]);

    static addWorkbookError(error: IWorkbookError) {
        this.addError(new WorkbookError(error));
    }

    //static addMappingError(error: IMappingError) {
    //    this.addError(new MappingError(error));
    //}

    private static addError(error: ErrorBase) {
        if (error.exception) {
            let self = this;
            StackTrace.fromError(error.exception).then(stackframes => {
                const filteredStack = stackframes.filter(sf =>
                    !sf.fileName.includes('stacktrace.min.js') &&
                    !sf.fileName.includes('ErrorService.ts')
                );

                let stack = filteredStack.map(sf => sf.toString()).join('\n');
                error.stackTrace = stack;

                self.errors.push(error);
            }).catch(err => {
                self.errors.push(error);
            });
        }
        else {
            this.errors.push(error);
        }
    }

    static clear() {
        this.errors([]);
    }

    static clearOfType(errorType: ErrorTypeEnum) {
        this.errors.removeAll(this.errors().filter(x => x.type === errorType));
    }
}